import React from 'react'

import '../stylesheets/components/Image.scss'

class Image extends React.Component {
    render() {
        return (
            <div className="Image">
                <img
                    src={process.env.REACT_APP_ASSET + '/cards/' + this.props.id + '.jpg'}
                    alt=""
                />
            </div>
        )
    }
}

export default Image
